import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

// Connects to data-controller="fade"
export default class extends Controller {
  out() {
    leave(this.element);
  }

  in() {
    enter(this.element);
  }
}
